import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';
import axiosHeadOffice from 'src/utils/axiosWOBaseUrl';

export const getVerificationData = createAsyncThunk(
  '/GetVerificationExecute',
  async () => {
    const response = await axiosHeadOffice.get('/HeadOffice/GetVerificationExecute');
    return response.data;
  }
);

export const getVerificationExecuteDetails = createAsyncThunk(
  '/getVerificationExecuteDetails',
  async (id) => {
    const response = await axiosHeadOffice.get(`/HeadOffice/GetVerificationExecuteDetails/${id}`);
    return response.data;
  }
);

export const getVerificationExecuteRules = createAsyncThunk(
  '/getVerificationExecuteRules',
  async (id) => {
    const response = await axiosHeadOffice.get(`/HeadOffice/GetVerificationExecuteRules/${id}`);
    return response.data;
  }
);

export const SaveVerificationExecuteData = createAsyncThunk(
  '/SaveVerificationExecuteData',
  async (data) => {
    const response = await axiosHeadOffice.post('/HeadOffice/SaveVerificationExecuteData',data)
    return response.data
  }
)

export const ChangeVerificationExecuteState = createAsyncThunk(
  '/ChangeVerificationExecuteState',
  async (data) => {
    const response = await axiosHeadOffice.post('/HeadOffice/ChangeVerificationExecuteState',data)
    return response.data
  }
)

export const getLanguagelist = createAsyncThunk(
  '/getLanguageList',
  async () => {
    const response = await axios.get('/GetLanguageList');
    return response.data;
  }
);

const VerificationExecuteSlice = createSlice({
  name: 'verificationRules',
  initialState: {
    loading: false,
    error: '',
    VerificationRules: [],
    VerificationRuleDescriptions: [],
    SelectedAppTranslationId: 0,
    response: '',
    VerificationExecuteRules:[]
  },
  reducers: {
    changeSelectedAppTranslationId(state, action) {
      state.SelectedAppTranslationId = action.payload;
    },
    resetDescriptions(state) {
      state.VerificationRuleDescriptions = [];
    },
    resetRules(state){
      if(state.VerificationExecuteRules && state.VerificationExecuteRules[0]){
        if(state.VerificationExecuteRules[0].MobileStatus && state.VerificationExecuteRules[0].Verification){
          state.VerificationExecuteRules[0].MobileStatus.forEach(function(item) {
            item.Active = false;
        });

        state.VerificationExecuteRules[0].Verification.forEach(function(item) {
             item.Active = false;
             item.Strict = false;
        });
        }
      } 
    }
  },
  extraReducers: {
    [getVerificationData.pending]: (state) => {
      state.loading = true;
    },
    [getVerificationData.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;

    },
    [getVerificationData.fulfilled]: (state, action) => {
      state.VerificationRules = action.payload;
      state.loading = false;
    },
    [getVerificationExecuteDetails.pending]: (state) => {
      state.loading = true;

    },
    [getVerificationExecuteDetails.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;

    },
    [getVerificationExecuteDetails.fulfilled]: (state, action) => {
      state.VerificationRuleDescriptions = action.payload;
      state.loading = false;
    },
    [getLanguagelist.pending]: (state) => {
      state.loading = true;
    },
    [getLanguagelist.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;

    },
    [getLanguagelist.fulfilled]: (state, action) => {
      state.VerificationRuleDescriptions = action.payload;
      state.loading = false;
    },
    [getVerificationExecuteRules.pending]: (state) => {
      state.loading = true;
    },
    [getVerificationExecuteRules.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;

    },
    [getVerificationExecuteRules.fulfilled]: (state, action) => {
      state.VerificationExecuteRules = action.payload;
      state.loading = false;
    }
  }
});

export const VerificationExecuteSliceActions = VerificationExecuteSlice.actions;

export default VerificationExecuteSlice;
